"use strict";
exports.__esModule = true;
exports.forAnimationFrame = void 0;
function forAnimationFrame() {
    return new Promise(function (resolve) {
        requestAnimationFrame(function (now) {
            // TODO: !!! What exactly is now?
            resolve(now);
        });
    });
}
exports.forAnimationFrame = forAnimationFrame;
